// 获取当前环境
// 使用方法： this.$getEnv()
export const getEnvFn = (type = "string") => {
  // type: string | boolean
  var currentDomain = window.location.hostname;
  // 定义线上环境的域名列表
  var productionDomains = ["www.fashionlabs.ai", "www.fashionlabs.cn"];
  if (productionDomains.includes(currentDomain)) {
    return type === "string" ? "production" : true; // 当前是生产环境
  } else {
    return type === "string" ? "development" : false; // 当前是开发环境
  }
};

export const getEnv = {
  install(Vue) {
    Vue.prototype.$getEnv = getEnvFn;
  },
};

// 判断是cn域名还是ai域名
export const getDomainFn = (type = "boolean") => {
  // type: string | boolean
  var currentDomain = window.location.hostname;
  if (currentDomain.includes(".ai")) {
    return type === "string" ? "ai" : true; // 当前是ai域名
  } else {
    return type === "string" ? "cn" : false; // 当前是cn域名
  }
};
